import {useEffect, useState} from "react";

export default function useMediaQuery(query: string) {
    const [matches, setMatches] = useState(false);

    useEffect(() => {
        if (!query) {
            return;
        }

        const media = window.matchMedia(query);

        const handleChange = () => {
            setMatches(media.matches);
        };

        // Call it once to check if we match initially:
        handleChange();

        // And then wire up listeners for future changes:
        media.addEventListener("change", handleChange);

        return () => media.removeEventListener("change", handleChange);
    }, [query]);

    return matches;
}
